import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

const fetchCheckEmail = ({ email }) => {
  return api.put(`/user/email`, { email });
};

export const useCheckEmailQuery = (email, checkEmailEnabled) => {
  return useQuery({
    queryKey: ["checkEmail", email],
    queryFn: () => fetchCheckEmail({ email }),
    enabled: checkEmailEnabled,
    select: (data) => {
      return data.data;
    },
  });
};
